import type { PageContext } from 'vike/types';

export default (pageContext: PageContext) => {
  const pathname = pageContext.urlPathname || '/';
  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];
  const supportedLocales = ['en', 'fi', 'sv'];
  const locale = supportedLocales.includes(firstSegment) ? firstSegment : 'en';

  const titleBase =
    locale === 'fi'
      ? 'Työnantajan pisteytys — miten JobCrawls pisteyttää työnantajia'
      : locale === 'sv'
        ? 'Arbetsgivarpoäng — hur JobCrawls rankar arbetsgivare'
        : 'Employer score — how JobCrawls ranks employers';

  return `${titleBase} | JobCrawls`;
};
